var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[(_vm.$config.logo)?_c('img',{staticClass:"logo-image",style:({
      width: _vm.$config.theme['@logo-width'],
      height: _vm.$config.theme['@logo-height']
    }),attrs:{"src":_vm.$config.logo}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }